export const SET_ENLIGHTEN_MANAGER_TOKEN = 'SET_ENLIGHTEN_MANAGER_TOKEN'

export const GET_GS_REQUESTS_FAILURE = 'GET_ALL_PROGRAMS_FAILURE'

export const SIGNUP_USER = 'SIGNUP_USER'
export const USER_SIGNUP_SUCCESS = 'USER_SIGNUP_SUCCESS'
export const USER_SIGNUP_FAILED = 'USER_SIGNUP_FAILED'

export const SIGNIN_USER = 'SIGNIN_USER'
export const USER_SIGNIN_SUCCESS = 'USER_SIGNIN_SUCCESS'
export const USER_SIGNIN_FAILED = 'USER_SIGNIN_FAILED'
export const USER_SERVER_DOWN = 'USER_SERVER_DOWN'

export const GET_ALL_STATES_REQUEST = 'GET_ALL_STATES_REQUEST'
export const GET_ALL_STATES_SUCCESS = 'GET_ALL_STATES_SUCCESS'

export const ADD_CURRENT_PROGRAM = 'ADD_CURRENT_PROGRAM'

export const GET_ALL_EVENTS_REQUEST = 'GET_ALL_EVENTS_REQUEST'
export const GET_ALL_SYSTEMS_REQUEST = 'GET_ALL_SYSTEMS_REQUEST'

export const GET_ALL_EVENTS_SUCCESS = 'GET_ALL_EVENTS_SUCCESS'
export const GET_ALL_SYSTEMS_SUCCESS = 'GET_ALL_SYSTEMS_SUCCESS'

export const PASSWORD_CHANGE = 'CHANGE_PASSWORD'
export const PASSWORD_CHANGE_SUCCESS = 'PASSWORD_CHANGE_SUCCESS'
export const PASSWORD_CHANGE_FAILED = 'PASSWORD_CHANGE_FAILED'

export const SIGNOUT_USER = 'SIGNOUT_USER'
export const USER_SIGNOUT_SUCCESS = 'USER_SIGNOUT_SUCCESS'
export const USER_SIGNOUT_FAILED = 'USER_SIGNOUT_FAILED'

export const GET_CURRENT_USER = 'GET_CURRENT_USER'
export const GET_CURRENT_USER_SUCCESS = 'GET_CURRENT_USER_SUCCESS'
export const CREATE_PROGRAM_REQUEST = 'CREATE_PROGRAM_REQUEST'
export const GET_ALL_PROGRAMS_REQUEST = 'GET_ALL_PROGRAMS_REQUEST'
export const GET_ALL_PROGRAMS_SUCCESS = 'GET_ALL_PROGRAMS_SUCCESS'

export const POST_FILE_REQUEST = 'POST_FILE_REQUEST'
export const POST_FILE_SUCCESS = 'POST_FILE_SUCCESS'

export const GET_PROGRAM_ENROLLMENT_METADATA_OF_CURRENT_PROGRAM_REQUEST =
  'GET_PROGRAM_ENROLLMENT_METADATA_OF_CURRENT_PROGRAM_REQUEST'

export const GET_PROGRAM_ENROLLMENT_METADATA_OF_CURRENT_PROGRAM_SUCCESS =
  'GET_PROGRAM_ENROLLMENT_METADATA_OF_CURRENT_PROGRAM_SUCCESS'

export const DOWNLOAD_FILE_REQUEST = 'DOWNLOAD_FILE_REQUEST'
export const DOWNLOAD_FILE_SUCCESS = 'DOWNLOAD_FILE_SUCCESS'
export const DELETE_FILE_REQUEST = 'DELETE_FILE_REQUEST'
export const DELETE_FILE_SUCCESS = 'DELETE_FILE_SUCCESS'

export const CLEAR_MESSAGE = 'CLEAR_MESSAGE'

export const GET_PROGRAM_BY_ID = 'GET_PROGRAM_BY_ID'
export const GET_PROGRAM_BY_ID_SUCCESS = 'GET_PROGRAM_BY_ID_SUCCESS'
export const GET_PROGRAM_BY_ID_NOT_FOUND = 'GET_PROGRAM_BY_ID_NOT_FOUND'